"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_ease = void 0;
exports.foundation_ease = {
    linear: {
        linear: 'cubic-bezier(1,1,1,1)',
    },
    in: {
        ease_in: 'cubic-bezier(1,0,0.83,0.83)',
        ease_in_back: 'cubic-bezier(0.39,0,0.57,-0.31)',
        ease_in_circ: 'cubic-bezier(0.64,0,0.83,0.83)',
        ease_in_cubic: 'cubic-bezier(0.39,0,0.7,0.15)',
        ease_in_expo: 'cubic-bezier(0.95,0.05,0.795,0.035)',
        ease_in_quad: 'cubic-bezier(0.55,0.085,0.68,0.53)',
        ease_in_quart: 'cubic-bezier(0.895,0.03,0.685,0.22)',
        ease_in_quint: 'cubic-bezier(0.69,0,0.71,0.37)',
        ease_in_sine: 'cubic-bezier(0.47,0,0.745,0.715)',
    },
    out: {
        ease_out: 'cubic-bezier(0.17,0.17,0,1)',
        ease_out_back: 'cubic-bezier(0.2,1.51,0.5,1.06)',
        ease_out_circ: 'cubic-bezier(0.03,0.51,0.43,1)',
        ease_out_cubic: 'cubic-bezier(0.35,0.98,0.67,1)',
        ease_out_expo: 'cubic-bezier(0.19,1,0.22,1)',
        ease_out_quad: 'cubic-bezier(0.25,0.46,0.45,0.94)',
        ease_out_quart: 'cubic-bezier(0.165,0.84,0.44,1)',
        ease_out_quint: 'cubic-bezier(0.755,0.05,0.855,0.06)',
        ease_out_sine: 'cubic-bezier(0.39,0.575,0.565,1)',
    },
    inOut: {
        ease_inOut: 'cubic-bezier(0.42,0,0.58,1)',
        ease_inOut_back: 'cubic-bezier(0.68,-0.55,0.265,1.55)',
        ease_inOut_circ: 'cubic-bezier(0.68,0,0.06,1)',
        ease_inOut_cubic: 'cubic-bezier(0.6,0,0.4,1)',
        ease_inOut_expo: 'cubic-bezier(0.33,0,0,1)',
        ease_inOut_quad: 'cubic-bezier(0.42,0,0.16,1)',
        ease_inOut_quart: 'cubic-bezier(0.77,0,0.175,1)',
        ease_inOut_quint: 'cubic-bezier(0.75,0,0.22,1)',
        ease_inOut_sine: 'cubic-bezier(0.445,0.05,0.55,0.95)',
    },
};
//# sourceMappingURL=ease.js.map